import {
    HTMLAttributes,
    ReactElement
} from "react";
import { Arrowleft, Calendar } from "../../assets";
interface Props extends HTMLAttributes<HTMLElement> {
    date: string;
    time: string;
    title: string;
    Unread?: boolean;
    onClick?:any
}
export function AnnouncementsCard2({ date, time, title, Unread , onClick }: Props): ReactElement {
    return (
        <div className={`${Unread && "colorful"} announcements-card2`} onClick={onClick}>
            <div className="details">
            <h2 className="title">
                {Unread && <div className="circle"></div>}
                {title}
            </h2>

            <div className="date-time">
                <img src={Calendar} className="ms-1" alt="هامرز" />
                <span className="item">
                    {date}
                </span>
                <span className="item">
                    {time}
                </span>
            </div>
            </div>
            <div className="img">
                <Arrowleft />
            </div>
        </div>
    )
}
export default AnnouncementsCard2;
